export const activityDetails = [
  {
    title: "We scheduled a meeting for next week",
    activity_type: "Meeting",
    status: "Read",
    created_date: "24/06/2025",
    key: 1,
  },
  {
    checkbox: true,
    title: "Had conversation with Fred regarding task",
    activity_type: "Calls",
    status: "Unread",
    created_date: "23/06/2025",
    key: 2,
  },
  {
    checkbox: true,
    title: "Analysing latest time estimation for new project",
    activity_type: "Tasks",
    status: "Favourite",
    created_date: "20/02/2024",
    key: 3,
  },
  {
    checkbox: true,
    title: "Store and manage contact data",
    activity_type: "Email",
    status: "Read",

    created_date: "15/03/2024",
    key: 4,
  },
  {
    checkbox: true,
    title: "Call John and discuss about project",
    activity_type: "Calls",
    status: "Unread",
    created_date: "12/04/2024",
    key: 5,
  },
  {
    checkbox: true,
    title: "Will have a meeting before project start",
    activity_type: "Meeting",
    status: "Favourite",
    created_date: "20/05/2024",
    key: 6,
  },
  {
    checkbox: true,
    title: "Will have a meeting before project start",
    activity_type: "Meeting",
    status: "Favourite",
    created_date: "20/05/2024",
    key: 7,
  },
  {
    checkbox: true,
    title: "Built landing pages",
    activity_type: "Email",
    status: "Unread",
    created_date: "06/07/2024",
    key: 8,
  },
  {
    checkbox: true,
    title: "Discussed budget proposal with Edwin",
    activity_type: "Calls",
    status: "Read",
    created_date: "02/09/2024",
    key: 9,
  },
  {
    checkbox: true,
    title: "Attach final proposal for upcoming project",
    activity_type: "Tasks",
    status: "Read",
    created_date: "15/11/2024",
    key: 10,
  },

];
